export default class IllegalMove extends Error {
    constructor(move, message) {
        super(`Move ${move.toString()}: ${message}`);
    }
}
